import { useAuthentication } from '@hulu/react-sso';
import { Typography } from '@hulu/react-style-components';
import React from 'react';
import styled from 'styled-components';

const HuluUserInfo = styled.div`
  padding: ${({ theme }): string => theme.spacers!.spacer04};

  & pre {
    text-align: left;
    height: 300px;
    overflow: auto;
    border-radius: ${({ theme }): string => theme.spacers!.spacer02};
    padding: ${({ theme }): string => theme.spacers!.spacer02};
    background: ${({ theme }): string => theme.colors!.colorGray4};
  }

  & details {
    text-align: left;
  }
`;

export function HuluUser(): JSX.Element | null {
  const context = useAuthentication();

  return (
    context.auth && (
      <HuluUserInfo>
        <Typography variant="h1">
          Hello {context.auth.first_name} {context.auth.last_name}
        </Typography>
        <details open={true}>
          <Typography component="summary" variant="body1">
            Here's your info:
          </Typography>
          <Typography component="pre" variant="body2">
            {JSON.stringify(context.auth, null, 3)}
          </Typography>
        </details>
      </HuluUserInfo>
    )
  );
}

export default HuluUser;
